import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './ZeroStatePrompt.css';

const propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  icon: PropTypes.string,
  promptText: PropTypes.string,
  btnText: PropTypes.string,
  onClick: PropTypes.func,
};

class ZeroStatePrompt extends PureComponent {
  render() {
    const {
      className,
      heading,
      subheading,
      icon,
      promptText,
      btnText,
      onClick,
      ...otherProps
    } = this.props;

    return (
      <div
        className={classnames('ZeroStatePrompt p-t-40 p-b-40', className)}
        {...otherProps}
      >
        <h2 className="semi-bold no-margin text-center">{heading}</h2>
        {subheading && (
          <h4 className="m-t-0 m-b-0 p-l-10 p-r-10 text-center">
            {subheading}
          </h4>
        )}
        <span className="fa-stack fa-2x fa-fw m-t-20">
          <i
            className="far fa-circle fa-stack-2x"
            style={{ color: '#e6e6e6' }}
          />
          <i className={classnames('fa fa-stack-1x', icon)} />
        </span>
        <p className="font-montserrat bold text-uppercase m-t-20">
          {promptText}
        </p>
        <button
          className="ZeroStatePrompt-cta btn btn-complete btn-cons"
          onClick={onClick}
        >
          <i className="ZeroStatePrompt-cta-icon fas fa-plus" /> {btnText}
        </button>
      </div>
    );
  }
}

ZeroStatePrompt.propTypes = propTypes;

export default ZeroStatePrompt;
